(function () {
  const PACKS = {
    1: {
      header: '30-Day Supply Subscription',
      days: 30,
      saving: 5,
      originalPrice: 35.00,
      freeShipping: false
    },

    3: {
      header: '60-Day Supply Subscription',
      days: 60,
      saving: 12,
      originalPrice: 105.00,
      freeShipping: true
    },

    6: {
      header: '180-Day Supply Subscription',
      days: 180,
      saving: 25,
      originalPrice: 210.00,
      freeShipping: true
    }
  };

  let currentPack = 1;
  let timer;
  let observer;
  let isEnhancing = false;

  function getPackFromElement(element) {
    let el = element;

    for (let i = 0; i < 6 && el; i++) {
      const text = (el.textContent || '').trim();

      if (/\b6\s*pack\b/i.test(text)) return 6;
      if (/\b3\s*pack\b/i.test(text)) return 3;
      if (/\b1\s*pack\b/i.test(text)) return 1;

      el = el.parentElement;
    }

    return null;
  }

  function findNativeOneTimePrice(container) {
    if (!container) return '';

    const prices = [...container.querySelectorAll('*')].filter((el) => {
      if (el.children.length) return false;
      if (el.closest('.aerox-one-time-pricing')) return false;

      return /\$\s?\d/.test(el.textContent || '');
    });

    return prices.length
      ? prices[prices.length - 1].textContent.trim()
      : '';
  }

  function priceToNumber(price) {
    if (!price) return 0;

    return (
      parseFloat(
        price.replace(/[^0-9.]/g, '')
      ) || 0
    );
  }

  function enhanceWidget() {
    if (isEnhancing) return;

    isEnhancing = true;

    if (observer) {
      observer.disconnect();
    }

    const config = PACKS[currentPack];

    document
      .querySelectorAll('.shopify_subscriptions_fieldset')
      .forEach((fieldset) => {
        const planCard = fieldset.querySelector('.plan_card');

        if (!planCard) return;

        const cards = [...planCard.children].filter(
          (el) => el.nodeType === 1
        );

        const oneTime = cards.find((card) =>
          /one[- ]time purchase/i.test(card.textContent)
        );

        const subscription = cards.find(
          (card) =>
            card !== oneTime &&
            /(subscription|deliver|off)/i.test(card.textContent)
        );

        if (!oneTime || !subscription) return;

        oneTime.classList.add('aerox-one-time-card');
        subscription.classList.add('aerox-subscription-card');

        /* ONE-TIME PURCHASE FIRST */
        oneTime.style.setProperty('order', '1', 'important');
        subscription.style.setProperty('order', '2', 'important');

        /* GET REAL SHOPIFY ONE-TIME PRICE */
        const actualOneTimePrice =
          findNativeOneTimePrice(oneTime);

        const actualOneTimeNumber =
          priceToNumber(actualOneTimePrice);

        /* SUBSCRIPTION PRICE = ONE-TIME PRICE MINUS SAVING */
        const subscriptionPrice =
          actualOneTimeNumber - config.saving;

        const displaySubscriptionPrice =
          `$${subscriptionPrice.toFixed(2)} AUD`;

        /* HIDE NATIVE SUBSCRIPTION TITLE */
        [...subscription.querySelectorAll('*')].forEach((el) => {
          if (
            el.children.length === 0 &&
            /subscription/i.test(el.textContent || '') &&
            !el.closest('.aerox-sub-header')
          ) {
            el.classList.add('aerox-native-plan-title');
          }
        });

        /* HIDE NATIVE SUBSCRIPTION PRICE */
        [...subscription.querySelectorAll('*')].forEach((el) => {
          if (
            el.children.length === 0 &&
            /\$\s?\d/.test(el.textContent || '') &&
            !el.closest('.aerox-sub-header') &&
            !el.closest('.aerox-sub-benefits')
          ) {
            el.classList.add('aerox-native-sub-price');
          }
        });

        /* SUBSCRIPTION HEADER */
        let header =
          subscription.querySelector('.aerox-sub-header');

        if (!header) {
          header = document.createElement('div');
          header.className = 'aerox-sub-header';
          subscription.prepend(header);
        }

        header.innerHTML = `
          <div class="aerox-sub-top">

            <div class="aerox-sub-heading">

              <div class="aerox-sub-title">
                ${config.header}
              </div>

              <div class="aerox-sub-subtitle">
                Auto-Delivered · Cancel Anytime
              </div>

            </div>

            <div class="aerox-sub-pricing">

              <span class="aerox-was-price">
                $${config.originalPrice.toFixed(2)} AUD
              </span>

              <span class="aerox-now-price">
                ${displaySubscriptionPrice}
              </span>

            </div>

          </div>
        `;

        /* BENEFITS */
        let benefits =
          subscription.querySelector('.aerox-sub-benefits');

        if (!benefits) {
          benefits = document.createElement('div');
          benefits.className = 'aerox-sub-benefits';
          subscription.appendChild(benefits);
        }

        benefits.innerHTML = `
          <div
            class="aerox-saving-benefit"
            style="
              font-weight: 800 !important;
              color: #159fe6 !important;
            "
          >
            💰 Save $${config.saving} on Every Order
          </div>

          <div>🔄 Never Run Out Again</div>

          <div>
            📦 ${config.days}-Day Supply, Automatically Delivered
          </div>

          <div>
            🛡️ Try It Risk-Free for 30 Days
          </div>

          ${
            config.freeShipping
              ? '<div>✈️ Free Australia-Wide Shipping</div>'
              : ''
          }

          <div>
            ⏸️ Pause, Skip or Cancel Anytime
          </div>
        `;

        /* HIDE NATIVE ONE-TIME PRICE */
        [...oneTime.querySelectorAll('*')].forEach((el) => {
          if (
            el.children.length === 0 &&
            /\$\s?\d/.test(el.textContent || '') &&
            !el.closest('.aerox-one-time-pricing')
          ) {
            el.classList.add(
              'aerox-native-one-time-price'
            );
          }
        });

        /* CUSTOM ONE-TIME PRICE */
        let oneTimePricing =
          oneTime.querySelector(
            '.aerox-one-time-pricing'
          );

        if (!oneTimePricing) {
          oneTimePricing =
            document.createElement('div');

          oneTimePricing.className =
            'aerox-one-time-pricing';

          oneTime.appendChild(oneTimePricing);
        }

        oneTimePricing.innerHTML = `
          <span class="aerox-one-time-was">
            $${config.originalPrice.toFixed(2)} AUD
          </span>

          <span class="aerox-one-time-now">
            ${actualOneTimePrice}
          </span>
        `;

        /* MAKE FULL CARDS CLICKABLE */
        [subscription, oneTime].forEach((card) => {
          if (card.dataset.aeroxClickable) return;

          card.dataset.aeroxClickable = 'true';

          card.addEventListener(
            'click',
            function (event) {
              if (
                event.target.closest(
                  'input, button, a, label'
                )
              ) {
                return;
              }

              const radio =
                card.querySelector(
                  'input[type="radio"]'
                );

              if (radio && !radio.checked) {
                radio.click();
              }
            }
          );
        });
      });

    isEnhancing = false;

    if (observer) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  /* PACK CLICKS */
  document.addEventListener(
    'click',
    function (event) {
      const pack = getPackFromElement(event.target);

      if (!pack) return;

      currentPack = pack;

      setTimeout(enhanceWidget, 100);
      setTimeout(enhanceWidget, 400);
    },
    true
  );

  /* VARIANT CHANGES */
  document.addEventListener(
    'change',
    function (event) {
      const pack = getPackFromElement(event.target);

      if (pack) {
        currentPack = pack;
      }

      setTimeout(enhanceWidget, 100);
      setTimeout(enhanceWidget, 400);
    },
    true
  );

  observer = new MutationObserver(function () {
    clearTimeout(timer);

    timer = setTimeout(
      enhanceWidget,
      150
    );
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  enhanceWidget();
})();